<template>
  <div>
    <div class="header">
      <div class="divs">
        <div class="fz18">联盟挂账</div>
      </div>
    </div>
    <div class="alliance">
      <ul>
        <div class="flex bgc h30">我的联盟</div>
        <li
          v-for="(item, index) in leaguelist"
          :key="item.id"
          :class="changedtype === item.id ? 'checked' : ''"
          @click="coalition(item, index)"
        >
          <span>{{ item.name }}</span>
        </li>
      </ul>
      <!-- 账单信息 -->
      <div class="Account" v-if="empty.length !== 0">
        <!-- 账单信息 -->
        <div>
          <h3 class="fz20 pb5 bgb7">账单信息</h3>
          <Row class="p15" :gutter="8">
            <Col span="3">当前应还:</Col>
            <Col span="5">{{ data.receivableAmt }}</Col>
          </Row>
        </div>
        <!-- 结算 -->
        <div>
          <h3 class="fz20 pb5 bgb7">结算约定情况</h3>
          <Row class="p15" :gutter="8">
            <Col span="3">回款方式:</Col>
            <Col span="10">{{ data.cashModeName }}</Col>
            <Col span="3">回款日期:</Col>
            <Col span="5">{{ data.cashDate }}</Col>
          </Row>
          <Row class="pb15" :gutter="8">
            <Col span="3">约定对账日期:</Col>
            <Col span="10">{{ data.accountDate }}</Col>
          </Row>
        </div>
        <!-- 信用额度 -->
        <div>
          <h3 class="fz20 pb5 bgb7">信用额度</h3>
          <Row class="p15" :gutter="8">
            <Col span="3">固定额度:</Col>
            <Col span="10">{{ data.creditLimit }}</Col>
            <Col span="3">临时额度:</Col>
            <Col span="5">{{ data.tempCreditLimit }}</Col>
          </Row>
          <Row :gutter="8">
            <Col span="3">临时额度有效日期：</Col>
            <Col span="10">{{ data.tempStart }}至{{ data.tempEnd }}</Col>
          </Row>
        </div>
      </div>
      <div v-if="empty.length === 0" class="empty">
        <img
          src="@/assets/images/lianm.png"
          style="width: 180px; height: 190px"
        />
        <!-- <h1>您暂无联盟挂账额度。</h1> -->
        <div class="flex">
          <div class="shoppingNull">
            <span
              class="iconfont icon-gantanhao-xianxingyuankuang"
              style="width: 17px; height: 17px; opacity: 1; margin-right: 9px"
            >
            </span>
            <span>抱歉！您还无联盟挂账额度~</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { coalitionifon } from '@/api/myweb/finance/autotrophy'
import { syncCreditMsglm } from '@/api/myweb/finance/autotrophy'
export default {
  data() {
    return {
      // 联盟
      leaguelist: [
        // {
        //   id: '1',
        //   name: '埃力克斯'
        // },
        // {
        //   id: '2',
        //   name: '艾森沃克'
        // }
      ],
      changedtype: '', // 变化
      data: {
        /* yh: '25.36',
        hkfs: '月结',
        hqrq: '每月25日',
        yddzrq: '每月15日',
        gded: '50000.00',
        lsed: '20000.00',
        lsedysrq: '2022年01月08日 至 2022年02月07日' */
      },
      yy: [],
      empty: []
    }
  },
  created() {
    this.syncCreditMsglist()
  },
  methods: {
    // 点击联盟
    coalition(item, index) {
      this.empty.filter((val, index) => {
        if (val.type == item.id) {
          this.data = val
          this.changedtype = val.type
        }
      })
    },
    // 联盟挂账数据
    async syncCreditMsglist() {
      const res = await syncCreditMsglm({})
      if (res.status) {
        var arr = []
        if (res.data.list.length > 0) {
          res.data.list.forEach((item) => {
            if (item.type > 1) {
              arr.push(item)
            }
          })
          this.empty = arr
          console.log(this.empty)
          if (this.empty.length > 1) {
            if (this.empty[0].type == 2) {
              this.leaguelist = [
                {
                  id: 2,
                  name: '埃力克斯'
                },
                {
                  id: 3,
                  name: '艾森沃克'
                }
              ]
            } else {
              this.leaguelist = [
                {
                  id: 3,
                  name: '艾森沃克'
                },
                {
                  id: 2,
                  name: '埃力克斯'
                }
              ]
            }
          } else if ((this.empty.length = 1)) {
            if (this.empty[0].type == 2) {
              this.leaguelist = [
                {
                  id: 2,
                  name: '埃力克斯'
                }
              ]
              console.log(this.leaguelist)
            } else {
              this.leaguelist = [
                {
                  id: 3,
                  name: '艾森沃克'
                }
              ]
            }
            console.log(this.empty.length)
          } else {
          }
          this.yy = res.data
          this.data = this.empty[0]
          // if()
          console.log(this.empty)
          this.changedtype = this.empty[0].type
          console.log(this.changedtype)
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>
